import { ExtractAddressUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform ExtractAddressUtil functions
    getAddress: ExtractAddressUtil.getAddress
};
